export default __webpack_public_path__ + "static/media/crypto.2b6265d0.png";